<template>
  <a v-if="href" :href="isLink" class="button" :class="iconArrow">
    <template v-if="hasIcon">
      <span class="icon" :class="iconClass"></span>
    </template>
    <span class="label"><slot></slot></span>
  </a>

  <button v-else class="button" :type="type" :class="iconArrow">
    <template v-if="hasIcon">
      <span class="icon" :class="iconClass"></span>
    </template>
    <span class="label"><slot></slot></span>
  </button>
</template>

<style lang="less" scoped>

  @import '../assets/styles/buttons';

  .button{
    height: @button-height;
    line-height: @button-height;
    border-radius: @sm-spacer + 5;
    padding: 0 @md-spacer;
    letter-spacing: 2px;
    .make_button(@blue);

    &.full      { width: ~"calc(100% - (@{md-spacer}) *2)"; }
    &.pink { .make_button(@pink) }
    &.purple  { .make_button(@purple) }
    &.green  {
      .make_button(@light-green, darken(@light-green, 60%));
      color: @dark-purple;
    }
    &.light-blue  {
      .make_button(@light-blue, darken(@light-blue, 60%));
    }

    [class^='icon-']::before,
    [class*=' icon-']::before {
      font-size: @lg-font-size;
      vertical-align: baseline;
    }
  }
</style>

<script>
  export default {
    props: {
      icon: String,
      type: {
        type: String,
        default: 'button'
      },
      href: String
    },
    computed: {
      iconClass() {
        return `icon-${this.icon}`
      },
      hasIcon() {
        return this.icon && this.icon.length > 0
      },
      isLink() {
        return this.href
      }
    }
  }
</script>



// WEBPACK FOOTER //
// RoundButton.vue?36c54f96